const settlements = {
  empty: 'No settlements made. Please add settlements to any branch of your choice',
  export: 'Export CSV',
  settled_amount: 'Settled amount',
  total_amount: 'Total amount',
  account: 'Account number',
  account_name: 'Account name',
  bank: 'Bank name',
  reference: 'Settled reference',
  table: {
    title: 'Settlement',
    customer: 'Customer Name',
    gross: 'Gross amount',
    net: 'Net amount',
    reference: 'Reference',
    method: 'Payment method',
    date: 'Date',
    filter: 'Filter',
    export: 'Export as CSV',
    details: 'Settlements Details'
  }
};

export default settlements;